<template>
  <div class="admin-consumers">
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>初期設定マニュアル
      </div>
    </el-card>
  
    <div class="upload-line">
      <el-upload
              class="install_upload"
              ref="install_upload"
              :action="install_guide_url"
              name="manual"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="install_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>簡単利用ガイド
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="tutorial_upload"
              ref="tutorial_upload"
              :action="tutorial_guide_url"
              name="manual"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="tutorial_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>ユーザマニュアル
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="user_upload"
              ref="user_upload"
              :action="user_guide_url"
              name="manual"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="user_submitUpload">アップロードする</el-button>
      </el-upload>
    </div> 
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル_TOP画面(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_upload"
              ref="movie_upload"
              :action="movie_guide_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_submitUpload">アップロードする</el-button>
      </el-upload>
    </div> 
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿ダークウェブ(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_darkweb_upload"
              ref="movie_darkweb_upload"
              :action="movie_darkweb_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_darkweb_submitUpload">アップロードする</el-button>
      </el-upload>
    </div> 
      <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿隠語(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_slung_upload"
              ref="movie_slung_upload"
              :action="movie_slung_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_slung_submitUpload">アップロードする</el-button>
      </el-upload>
    </div> 
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿検索(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_search_upload"
              ref="movie_search_upload"
              :action="movie_search_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_search_submitUpload">アップロードする</el-button>
      </el-upload>
    </div> 
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿身元秘匿&感染フリー機能(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_undercover_upload"
              ref="movie_undercover_upload"
              :action="movie_undercover_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_undercover_submitUpload">アップロードする</el-button>
      </el-upload>
    </div> 
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿表示不要サイト(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_whitelist_upload"
              ref="movie_whitelist_upload"
              :action="movie_whitelist_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_whitelist_submitUpload">アップロードする</el-button>
      </el-upload>
    </div> 
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿サイト分析(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_investigate_upload"
              ref="movie_investigate_upload"
              :action="movie_investigate_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_investigate_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿個別視察対象(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_blacklist_upload"
              ref="movie_blacklist_upload"
              :action="movie_blacklist_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_blacklist_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>

    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿自動重点観測(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_crawler_upload"
              ref="movie_crawler_upload"
              :action="movie_crawler_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_crawler_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>

    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿閲覧履歴(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_history_upload"
              ref="movie_history_upload"
              :action="movie_history_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_history_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>
    
    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿お気に入り(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_bookmark_upload"
              ref="movie_bookmark_upload"
              :action="movie_bookmark_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_bookmark_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>

    <el-card class="title-block" shadow="never" :body-style="{padding: '12px'}">
      <span class="fa-stack fa-2x logo">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-cog fa-stack-1x fa-inverse"></i>
      </span>
      <div class="title">
        <div class="meta">設定</div>動画マニュアル＿設定(動画形式：mp4)
      </div>
    </el-card>
    <div class="upload-line">
      <el-upload
              class="movie_setting_upload"
              ref="movie_setting_upload"
              :action="movie_setting_url"
              name="movie"
              :auto-upload="false"
              :multiple="false"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeUpload"
              :on-change="onChange"
              :headers="xsrfHeaders">
        <el-button slot="trigger" size="small" type="primary">ファイル選択</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="movie_setting_submitUpload">アップロードする</el-button>
      </el-upload>
    </div>
  </div>
</template>

<script>
import AdminTemplate from "@/components/admin/Template";
import { AdminEventBus } from "@/components/admin/EventBus";
import axios from "axios";

export default {
  components: {
    AdminTemplate,
  },
  data() {
    const title = "マニュアルアップロード";

    return {
      title,
      install_guide_url :"/api/consumers/manuals/install_guide/",
      user_guide_url :"/api/consumers/manuals/user_guide/",
      tutorial_guide_url :"/api/consumers/manuals/tutorial_guide/",
      movie_guide_url :"/api/consumers/manuals/movie_guide/",
      movie_darkweb_url :"/api/consumers/manuals/movie_darkweb/",
      movie_slung_url :"/api/consumers/manuals/movie_slung/",
      movie_search_url :"/api/consumers/manuals/movie_search/",
      movie_undercover_url :"/api/consumers/manuals/movie_undercover/",
      movie_whitelist_url :"/api/consumers/manuals/movie_whitelist/",
      movie_investigate_url :"/api/consumers/manuals/movie_investigate/",
      movie_blacklist_url :"/api/consumers/manuals/movie_blacklist/",
      movie_crawler_url :"/api/consumers/manuals/movie_crawler/",
      movie_history_url :"/api/consumers/manuals/movie_history/",
      movie_bookmark_url :"/api/consumers/manuals/movie_bookmark/",
      movie_setting_url :"/api/consumers/manuals/movie_setting/",

    };
  },
  computed: {
    xsrfHeaders: function() {
      for (let c of document.cookie.split("; ")) {
        if (c.startsWith("csrftoken=")) {
          return { "X-CSRFToken": c.slice(10) };
        }
      }
      return {};
    }
  },
  methods: {
    install_submitUpload() {
      this.$refs.install_upload.submit();
    },
    user_submitUpload() {
      this.$refs.user_upload.submit();
    },
    tutorial_submitUpload() {
      this.$refs.tutorial_upload.submit();
    },
    movie_submitUpload() {
      this.$refs.movie_upload.submit();
    },
    movie_darkweb_submitUpload() {
      this.$refs.movie_darkweb_upload.submit();
    },
    movie_slung_submitUpload() {
      this.$refs.movie_slung_upload.submit();
    },
    movie_search_submitUpload() {
      this.$refs.movie_search_upload.submit();
    },
    movie_undercover_submitUpload() {
      this.$refs.movie_undercover_upload.submit();
    },
    movie_whitelist_submitUpload() {
      this.$refs.movie_whitelist_upload.submit();
    },
    movie_investigate_submitUpload() {
      this.$refs.movie_investigate_upload.submit();
    },
    movie_blacklist_submitUpload() {
      this.$refs.movie_blacklist_upload.submit();
    },
    movie_crawler_submitUpload() {
      this.$refs.movie_crawler_upload.submit();
    },
    movie_history_submitUpload() {
      this.$refs.movie_history_upload.submit();
    },
    movie_bookmark_submitUpload() {
      this.$refs.movie_bookmark_upload.submit();
    },
    movie_setting_submitUpload() {
      this.$refs.movie_setting_upload.submit();
    },
    handleUploadSuccess(res, file) {
      this.$refs.install_upload.clearFiles();
      this.$refs.user_upload.clearFiles();
      AdminEventBus.$emit("refresh");
    },
    beforeUpload(file) {
      return true;
    },
    handleUploadError(err, res, file) {
      console.log(err);
    },
    onChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.shift();
      }
    },
  }
};
</script>

<style scoped>
.logo {
  color: #012c63;
}
.title {
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  font-weight: bold;
  margin-left: 12px;
}
.meta {
  color: #666;
  font-size: 14px;
  font-weight: normal;
}
.upload-line{
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 12px;

}
</style>


